import {useModalManager} from '@basicComponents/sequential-modal/ModalManagerProvider';
import React from 'react';
import WinModal, {
  MODAL_ID,
} from '@/common-pages/leaderboard/components/Modal/win';
import InviteModal from '@/common-pages/leaderboard/components/Modal/invite';

export function useResultModal() {
  const {showModal} = useModalManager();
  const openModal = (config: {
    rank: number;
    reward: any;
    hasReward: boolean;
    inviteScore?: number;
    inviteCount?: number;
  }) => {
    const {reward, rank, inviteScore, inviteCount, hasReward} = config;
    const modals: React.ReactNode[] = [];
    if (reward && hasReward) {
      modals.push(<WinModal visible={true} rank={rank} reward={reward} />);
    }
    if (inviteScore) {
      modals.push(
        <InviteModal
          inviteScore={inviteScore}
          inviteCount={inviteCount || 0}></InviteModal>,
      );
    }
    if (modals.length === 0) {
      return;
    }

    showModal({
      id: MODAL_ID,
      overlayClassName: 'bg-black/80',
      backdropBlur: true,
      modals,
    });
  };
  return {
    openModal,
  };
}
